import { Component } from '@angular/core';
import { IonApp, IonContent } from '@ionic/angular/standalone';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { MenuComponent } from './shared/components/menu/menu.component';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [IonContent, IonApp, RouterOutlet, HeaderComponent, FooterComponent, MenuComponent]
})
export class AppComponent {

}
